import { makePropCacheMixin } from '../utils/cache'

export const attrsMixin = makePropCacheMixin('$attrs', 'bvAttrs')
